import { entity, list } from "./base";

const initialEntity = {
  id: null,
  form_title: "",
  form_id: null,
  publish_from: null,
  publish_to: null,
  description: ""
};

export const questionnaires = {
  namespaced: true,
  modules: {
    list: list("questionnaires"),
    entity: entity("questionnaires", initialEntity)
  }
};
